import React from "react";
import classes from "./BlogCard.module.css";
import { mergeClass } from "../../../resources/utils/helper";

export const ArticlesCardMain = ({
  data,
}) => {
  return (
    <div
      className={mergeClass(" cursor-pointer ", classes.cardContainer)}
    >
      <div className={classes.imageContainer}>
        <img
          src={data?.image}
          alt="Card Image"
          className={classes.cardImage}
          width={100}
          height={100}
        />
      </div>

      <div className={classes.contentContainer}>
        <div className={classes.title}>
          <p className="fs-35 fw-700 maxLine2">{data?.title}</p>
        </div>

        <div className={classes.detail}>
          <p className="maxLine6 fs-20">{data?.description}</p>
        </div>
        <div className={classes.date}>
          <p className="fs-21 fw-700">{data?.date}</p>
        </div>
      </div>
    </div>
  );
};
